<template>
  <div class="footer">
    <div class="footer_line"></div>
    <div class="footer_title">商务合作</div>
    <div class="footer_contact">
      <input
        type="text"
        v-model="cooperationArea"
        placeholder="请填写所在区域"
      />
      <div class="phone_number">
        <input
          type="text"
          v-model="phoneNumber"
          maxlength="11"
          placeholder="请填写手机号码"
        />
        <span v-show="show" @click="getCode">获取验证码</span>
        <span v-show="!show">{{ count }}秒重发</span>
      </div>
      <input type="text" v-model="code" placeholder="请填写验证码" />
      <div class="btn" @click="submit">在线提交</div>
    </div>
    <div class="footer_about">
      <div class="menu">
        <div class="menu_item" v-for="(item, index) in menu" :key="index">
          <div class="menu_item_title">{{ item.title }}</div>
          <div
            @click="goToRoute(item2)"
            class="menu_item_text"
            v-for="(item2, index2) in item.list"
            :key="index2"
          >
            {{ item2.title }}
          </div>
        </div>
      </div>
      <div class="information">
        <div>全国统一客服电话：400-6399580</div>
        <div>商务合作：19943433777</div>
        <div>公司地址：北京市朝阳区双井街道西大望路22号合生汇写字楼702室</div>
        <div>邮箱：liuyang@dinghanwang.com</div>
        <div class="information_img">
          <div
            class="information_img_item"
            v-for="(item, index) in account"
            :key="index"
          >
            <img :src="item.img" alt="" />
            <div>{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_line" style="margin-top: 30px"></div>
    <div class="footer_bot">
      鼎函科技有限公司 版权所有 <a style="color: #fff;" href="https://beian.miit.gov.cn/">京ICP备2022017360号</a> 京公网安备 11010502050505号
    </div>
    <Verify
      ref="verify"
      :captcha-type="'blockPuzzle'"
      :img-size="{ width: '354px', height: '216px' }"
    />
  </div>
</template>

<script>
import {
  saveBusCooperatio,
  sendCheckCode,
  useCheckCode,
} from "../api/basic/index.js";
import { validatePhone, validateTelephone } from "@/utils/validate";
import Verify from "@/components/verifition/Verify.vue"
export default {
  name: "",
  mixins: [],
  components: {
    Verify
  },
  provide() {
    return {
      sendCheckCodeWithSlider: this.sendCheckCodeWithSlider
    };
  },
  data() {
    return {
      cooperationArea: "",
      phoneNumber: "",
      dataForm: {
        cooperationArea: "",
        phoneNumber: "",
        policyNo: "",
        businessType: 1,
      },
      code: "",
      show: true,
      timer: null,
      count: "获取验证码",
      menu: [
        {
          title: "产品中心",
          list: [
            { id: "1", title: "投标保函", path: "/pc/produce", tabIndex: "1" },
            { id: "2", title: "合同履约保函", path: "/pc/produce", tabIndex: "2" },
            {
              id: "3",
              title: "工程款支付保函",
              path: "/pc/produce",
              tabIndex: "3",
            },
            { id: "4", title: "预付款保函", path: "/pc/produce", tabIndex: "4" },
            { id: "5", title: "工程质量保函", path: "/pc/produce", tabIndex: "5" },
            {
              id: "6",
              title: "农民工工资支付保函",
              path: "/pc/produce",
              tabIndex: "6",
            },
          ],
        },
        {
          title: "资讯中心",
          list: [
            { id: "1", title: "公司动态", path: "/pc/news", tabIndex: "1" },
            { id: "2", title: "政策解读", path: "/pc/news", tabIndex: "2" },
            { id: "3", title: "行业资讯", path: "/pc/news", tabIndex: "3" },
            { id: "4", title: "干货分享", path: "/pc/news", tabIndex: "4" },
            { id: "5", title: "时事热点", path: "/pc/news", tabIndex: "5" },
            /*{ id: "6", title: "收费标准", path: "/pc/news", tabIndex: "6" },*/ // todo
          ],
        },
        {
          title: "关于我们",
          list: [
            { id: "1", title: "公司简介", path: "/pc/about", tabIndex: "1" },
            { id: "2", title: "联系我们", path: "/pc/about", tabIndex: "3" },
            { id: "3", title: "合作机构", path: "/pc/partner", tabIndex: "0" },
            { id: "4", title: "意见反馈", path: "/pc/about", tabIndex: "4" },
          ],
        },
        {
          title: "更多服务",
          list: [
            { id: "1", title: "保函查验", path: "/pc/service", tabIndex: "1" },
            { id: "2", title: "理赔申请", path: "/pc/service", tabIndex: "2" },
            { id: "3", title: "信用查询", path: "/pc/credit", tabIndex: "2" },
          ],
        },
      ],
      account: [
        {
          img: require("../../static/other/footer-img1.jpg"),
          name: "微信公众号",
        },
        { img: require("../../static/other/footer-img2.jpg"), name: "抖音号" },
        {
          img: require("../../static/other/footer-img3.jpg"),
          name: "微信客服",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    goToRoute(item) {
      let path = item.path,
        tabIndex = item.tabIndex;
      this.$router.push({ path, query: { tabIndex } });
    },
    getCode() {
      if (!this.phoneNumber) {
        this.$message.error("请先输入手机号");
        return;
      }
      if (
        (!validatePhone(this.phoneNumber) &&
          !validateTelephone(this.phoneNumber)) ||
        this.phoneNumber.length != 11
      ) {
        this.$message({
          title: "提示",
          message: "请输入正确的联系电话",
          type: "warning",
        });
      } else {
        //查询是否进行行为认证
        this.$refs.verify.show();
      }
    },
    // 发送验证码带滑块
    async sendCheckCodeWithSlider(sliderParams) {
      this.getVerifyCode();
      const params = {
        phone: this.phoneNumber,
        businessCode: "globalTemplate",
        graphicData:sliderParams,
      }
      try{
        await sendCheckCode(params)
        this.$message.success({
          title: '提示',
          message: '短信发送成功，请注意查收',
          type: 'success',
        });
        return true
      }catch (e){
        return false
      }
    },
    getVerifyCode() {
      this.show = false;
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    submit() {
      if (
        this.phoneNumber && this.cooperationArea && this.code
      ) {
        const phoneParams = {
          phone: this.phoneNumber,
          businessCode: 'globalTemplate',
          checkCode: this.code
        };
        useCheckCode(phoneParams).then((phoneRes) => {
          if (phoneRes.data.resultCode == '200') {
            this.saveBusCooperatio()
          }

        });
      } else {
        this.$message.error("请按照页面信息填写完整");
      }
    },
    saveBusCooperatio(){
      this.dataForm.phoneNumber = this.phoneNumber
      this.dataForm.cooperationArea = this.cooperationArea
      saveBusCooperatio(this.dataForm).then((res) => {
            if(res.data.resultCode == '200') {
              this.clear()
              this.$message({
                message: '提交成功！稍后会有客服人员联系您。',
                type: 'success'
            });
            }
          });
    },
    clear(){
      this.cooperationArea=''
      this.phoneNumber = "";
      this.code = "";
      this.show= true;
      this.timer=null;
      this.count="获取验证码";
    },
  },
};
</script>

<style scoped >
.footer {
  margin: auto;
  width: 1200px;
}
.footer_line {
  width: 100%;
  height: 1px;
  background: rgb(225, 225, 225);
}
.footer_contact {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.footer_contact > input {
  width: 300px;
  height: 40px;
  line-height: 40px;
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;
}
.phone_number {
  background: #fff;
  width: 350px;
  height: 40px;
  line-height: 40px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
  box-sizing: border-box;
}
.phone_number > input {
  width: 220px;
  height: 100%;
  margin-right: 10px;
  outline: none;
  border: 0 none;
  font-size: 14px;
  float: left;
  text-indent: 10px;
}
.phone_number > span {
  float: right;
  cursor: pointer;
  padding: 5px 15px;
  line-height: 30px;
  color:rgb(26, 127, 221);
  user-select: none;
  transition: background-color 0.3s ease;
}
.btn {
  width: 90px;
  height: 40px;
  background: rgb(26, 127, 221);
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  cursor: pointer;
}
.footer_title {
  font-size: 30px;
  font-weight: 700;
  margin: 30px 0;
}
.footer_about {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.menu {
  display: flex;
  width: 50%;
}
.menu_item {
  margin-right: 50px;
}
.menu_item_title {
  font-size: 18px;
  margin-bottom: 30px;
}
.menu_item_text {
  margin-bottom: 10px;
  color: #494949;
  cursor: pointer;
}
.information {
  width: 50%;
  line-height: 30px;
  padding-left: 120px;
  box-sizing: border-box;
}
.information_img {
  display: flex;
}
.information_img_item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 30px 30px 30px 0;
}
.information_img_item > img {
  width: 100px;
}
.footer_bot {
  text-align: center;
  color: #ededed;
  margin: 30px;
}
input,
button,
textarea,
select,
optgroup,
option {
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
}
</style>
